import { z } from "zod/v4";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ButtonGroup, Stack } from "@mui/material";
import { Form, FormProps, useFormContext, useStore } from "@/components/form";

const editTransferenciaMetodoFormDetailSchema = z.object({
    id: z.string().optional(),
    nombre: z.string().nonempty("Este campo es requerido"),
    metodoBase: z.boolean().default(false),
    hidden: z.boolean().default(false),
});

export const editTransferenciaMetodoFormSchema = z.object({
    details: z.array(editTransferenciaMetodoFormDetailSchema)
});

export default function EditTransferenciaMetodoForm({
    form,
    ...props
}: FormProps<z.input<typeof editTransferenciaMetodoFormSchema>>) {
    return <Form form={form as any} gap={3} {...props}>
        <form.Field name="details" mode="array">
            {field => <>
                {field.state.value.map((m, i) => m.metodoBase ? <MetodoTransferenciaBaseField key={i} index={i} /> :
                    m.id ? <MetodoTransferenciaField key={i} index={i} /> :
                        <MetodoTranferenciaRemovableField key={i} index={i} onRemove={() => field.removeValue(i)} />
                )}
                <Form.Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => field.pushValue({ nombre: "", metodoBase: false, hidden: false })}
                >Nuevo Método de Transferencia</Form.Button>
            </>}
        </form.Field>
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}

function MetodoTransferenciaBaseField({ index }: { index: number }) {
    const form = useFormContext();
    const metodoTransferncia = useStore(form.store, state => state.values.details[index]);

    return <Stack direction={"row"} gap={2} alignItems={"center"}>
        <Stack flex={2}>
            <Form.TextField name={`details[${index}].nombre`} label="Principal" disabled={metodoTransferncia.hidden} />
        </Stack>
    </Stack>
}

function MetodoTransferenciaField({ index }: { index: number }) {
    const form = useFormContext();
    const metodoTransferncia = useStore(form.store, state => state.values.details[index])

    return <Stack direction={"row"} gap={2} alignItems={"center"}>
        <SortOrderButtons index={index} />
        <Stack flex={2}>
            <Form.TextField name={`details[${index}].nombre`} label="Nombre" disabled={metodoTransferncia.hidden} />
        </Stack>
        <Stack>
            <Form.IconButton onClick={() => form.setFieldValue(`details[${index}].hidden`, !metodoTransferncia.hidden)}>
                {!metodoTransferncia.hidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </Form.IconButton>
        </Stack>
    </Stack>
}

function MetodoTranferenciaRemovableField({ index, onRemove }: { index: number, onRemove: () => void }) {
    return <Stack direction={"row"} gap={2} alignItems={"center"}>
        <SortOrderButtons index={index} />
        <Stack flex={2}>
            <Form.TextField name={`details[${index}].nombre`} label="Nuevo Método" />
        </Stack>
        <Stack>
            <Form.IconButton onClick={onRemove}>
                <CloseIcon />
            </Form.IconButton>
        </Stack>
    </Stack>
}

interface SortOrderButtonsProps {
    index: number
}

function SortOrderButtons({
    index
}: SortOrderButtonsProps) {
    const form = useFormContext();

    const details = useStore(form.store, state => state.values.details);

    const handleUpClick = () => {
        if (index - 1 >= 1) form.moveFieldValues("details", index, index - 1)
    }

    const handleDownClick = () => {
        if (index + 1 < details.length) form.moveFieldValues("details", index, index + 1)
    }

    return <Stack>
        <ButtonGroup orientation="vertical" size="small" variant="text" color="inherit" >
            <Form.Button size="small" onClick={handleUpClick} sx={{ width: "30px" }} disabled={index - 1 < 1} >
                <ArrowDropUpIcon fontSize="small" />
            </Form.Button>
            <Form.Button size="small" onClick={handleDownClick} sx={{ width: "30px" }} disabled={index + 1 >= details.length}>
                <ArrowDropDownIcon fontSize="small" />
            </Form.Button>
        </ButtonGroup>
    </Stack>
}